import { httpClient } from '@/services/http/httpClient'

type DeleteCommentProps = {
  commentId: string
  projectId: string
}
export async function deleteComment({
  commentId,
  projectId,
}: DeleteCommentProps) {
  await httpClient.delete(
    `/projects/project-comments/${projectId}/${commentId}`,
  )
}
